import { setPage } from '@job-facets/redux/jobsFilterSlice';
// import { isDesktopDevice } from '@core/components/utility';

/**
 * Setup scroll logics
 */
function scrollOnPaginationClick() {
	try {
		// id of the element for scrolling
		// this element is virtually created using Reactjs
		// and is used for scrolling to top of the page
		const defaultScrollEle = '[data-js-used-for-pagination-scrolling]';

		document.querySelector(defaultScrollEle)?.scrollIntoView(true);
	} catch (e) {
		console.error(e);
	}
}

/**
 * Execute series of functions when pagination items changes
 * @param {number} page
 * @param {function} dispatch
 */
function onPaginate(page, dispatch) {
	dispatch(setPage(page));
	scrollOnPaginationClick();
}

export default onPaginate;
